import { Box, Button, Dialog, Paper, Stack } from '@mui/material'
import { FC } from 'react'

interface InterruptionPanelProps {
  open: boolean
  prompt: string
  details?: string
  firstOption: string
  secondOption: string
  firstOptionTestId?: string
  secondOptionTestId?: string
  onClose: () => void
  onSelection: (confirmed: boolean) => void
}

export const InterruptionPanel: FC<InterruptionPanelProps> = ({
  open,
  prompt,
  details,
  firstOption,
  secondOption,
  firstOptionTestId = 'interruption-panel-first-option-button',
  secondOptionTestId = 'interruption-panel-second-option-button',
  onClose,
  onSelection
}) => {
  const handleSelectionClick = (option: string) => {
    onSelection(option === firstOption)
  }

  return (
    <Dialog open={open} onClose={onClose} data-testid={`interruption-panel-${prompt}`}>
      <Paper
        data-testid="interruption-panel"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--spacing-2xs)',
          padding: 'var(--spacing-m)',
          width: '600px',
          height: '200px'
        }}
      >
        <Box sx={{ fontSize: 'var(--size-l)', fontWeight: '500' }}>{prompt}</Box>
        {details && <Box sx={{ fontSize: '16px', fontWeight: '400' }}>{details}</Box>}
        <Stack direction="row" spacing={1} sx={{ mt: 'auto', justifyContent: 'flex-end' }}>
          <Button
            data-testid={firstOptionTestId}
            variant="outlined"
            onClick={() => handleSelectionClick(firstOption)}
            sx={{ fontSize: 'var(--size-s)' }}
          >
            {firstOption}
          </Button>
          <Button
            data-testid={secondOptionTestId}
            variant="outlined"
            onClick={() => handleSelectionClick(secondOption)}
            sx={{ fontSize: 'var(--size-s)' }}
          >
            {secondOption}
          </Button>
        </Stack>
      </Paper>
    </Dialog>
  )
}
